import packageJson from "../../package.json";

export const PHONE_CODE = "+1 242";
export const COUNTRY_NAME = "The Bahamas";

export const ERROR_MESSAGE = {
  error501: "Something went wrong",
  incompleteForm: "Please fill the above details first.",
  profileError: "Profile setup already done for this profile!",
};

export const FIELD_VALIDATIONS = {
  firstName: "First Name is required.",
  lastName: "Last Name is required.",
  phone: "Phone Number is required.",
  fbo: "ABO Name is required.",
  addressLine1: "Address Line 1 is required.",
  zipCode: "Zip Code is required.",
  country: "Country is required.",
  airline: "Airline access is required.",
  airport: "Airport selection is required.",
  fboRole: "Role selection is required.",
};

export const ADD_FUEL_METER_SUCCESS_MESSAGE = "Fuel meter added successfully.";

export const FUEL_METER_READING_SUBMIT_MESSAGE =
  "Fuel meter reading submitted successfully.";

export const INVITE_SENT_SUCCESS_MESSAGE = "Invite sent successfully.";

export const FBO_TYPE = {
  LANDING_FEE: "landing-fee",
  FUEL_ROYALTY: "fuel-royalty",
  AIRPORT_BASED_OPERATORS: "airport-based-operators",
};

export const ACCOUNT_ROLE_STATUS = [
  { id: 1, name: "Airline admin", value: "AIRLINE_ADMIN" },
  {
    id: 2,
    name: "Airline agent",
    value: "AIRLINE_AGENT",
  },
];

export const FBO_CUSTOMER_ROLE = [
  { id: 1, name: "ABO Admin", value: "FBO_ADMIN" },
  {
    id: 2,
    name: "ABO Employee",
    value: "FBO_EMPLOYEE",
  },
];

export const ACCOUNT_APPROVAL_STATUS = [
  { id: 1, name: "Approved", value: "APPROVED", color: "#41D269" },
  { id: 2, name: "Rejected", value: "REJECTED", color: "#E8505B" },
];

export const ABO_ROLE = {
  FBO_ADMIN: "ABO Admin",
  FBO_EMPLOYEE: "ABO Employee",
};

export const PAYMENT_METHOD = {
  WIRE_TRANSFER: "Wire Transfer",
  CREDIT_CARD: "Credit Card",
};

export const INVOICE_STATUS = {
  OVERDUE: "Overdue",
  PARTIAL_PAYMENT: "Partial Payment",
  CREATED: "New",
};

export const PAGINATION_PAGE_SIZE = 10;

export const ACCOUNT_REJECTION_REASON = [
  { id: 1, label: "Reason 1" },
  { id: 2, label: "Reason 2" },
  { id: 3, label: "Reason 3" },
  { id: 4, label: "Reason 4" },
  { id: 5, label: "Reason 5" },
];

export const LAND_LEASE_TYPE = [
  { name: "Office Space", value: "OFFICE_SPACE", },
  {
    name: "Restaurant",
    value: "RESTAURANT",
  },
  {
    name: "Counter Space",
    value: "COUNTER_SPACE",
  },
  {
    name: "Land Lease",
    value: "LAND_LEASE",
  }
];

export const DefaultConfigValues = {
  REACT_APP_KEYCLOAK_URL: "https://keycloak.airportauthority.net/",
  REACT_APP_KEYCLOAK_REALM: "Airport-Authority",
  REACT_APP_KEYCLOAK_CLIENT_ID: "fbo-web-app",
  REACT_APP_API_URL: "https://services.airportauthority.net/",
  REACT_APP_PLUGNPAY_URL: "https://pay1.plugnpay.com/pay/",
  REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT: "demorsl",
  REACT_APP_PROFILE_ENV: "dev",
  REACT_APP_VERSION: packageJson.version,
  REACT_APP_SENTRY_DSN:
    "https://b6dc1bbd251ea80feb6bcd833edfe7ee@o4509546647519232.ingest.us.sentry.io/4509558898819072",
};

export const DATE_FORMAT = "DD MMM, YYYY";
export const TIME_FORMAT = "HH:mm";

// Date format constants for API requests and data processing
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const API_TIME_FORMAT = "HH:mm:ss";
export const API_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";

export const PAYMENT_CONSTANTS = {
  CURRENCY: "BSD",
  COUNTRY: "BS",
  TRANSITION_TYPE: "hidden",
  DEFAULT_PAYMENT_TYPE: "credit",
  PAYMENT_TYPES: {
    WIRE: "wire",
    CREDIT: "credit",
  },
  PAYMENT_LABELS: {
    WIRE: "Wire Transfer",
    CREDIT: "Credit/Debit Card",
  },
};

export const PAYMENT_FORM_FIELDS = {
  GATEWAY_ACCOUNT: "pt_gateway_account",
  AMOUNT: "pt_transaction_amount",
  CURRENCY: "pt_currency",
  CUSTOM_NAME_1: "pt_custom_name_1",
  CUSTOM_VALUE_1: "pt_custom_value_1",
  CUSTOM_NAME_2: "pt_custom_name_2",
  CUSTOM_VALUE_2: "pt_custom_value_2",
  PAYMENT_TYPE: "pd_transaction_payment_type",
  BILLING_COUNTRY: "pt_billing_country",
  RESPONSE_URL: "pb_response_url",
  EMAIL: "pt_billing_email_address",
  TRANSITION_TYPE: "pb_transition_type",
  SUBMIT: "submit",
};

export const PAYMENT_FORM_VALUES = {
  PAYMENT_TYPE: "swipe",
  CUSTOM_NAME_1: "invoices",
  CUSTOM_NAME_2: "customer_number",
  SUBMIT: "pay",
};

export const PAYMENT_DIALOG = {
  WIRE_REFERENCE: {
    TITLE: "Enter Payment Details",
    HELPER_TEXT:
      "You need to enter Payment reference number, provided by your bank after successful transfer. If you haven't initiated the transfer,",
    LINK_TEXT: "click here",
    LINK_SUFFIX:
      "to go back and see the bank details to initiate the transfer.",
    PLACEHOLDER: "Enter reference number",
    PAYMENT_PLACEHOLDER: "Enter payment amount",
    SAVE_BUTTON: "Save",
  },
  BANK_DETAILS: {
    TITLE: "Bank Details",
    BANK_NAME: "Bahamas Bank",
    ACCOUNT_NUMBER: "09843793293792",
    SWIFT_CODE: "SZU8949",
    DONE_BUTTON: "Done",
  },
};
export const PLATFORM_PROFILE_FBO_TYPE = "FBO_USER";
export const PLATFORM_TYPE = "FBO_APP";
export const APP_NAME = "aa-fbo-app";
export const VERSION_KEY = `${APP_NAME}:lastSeenVersion`;

export const REJECTION_REASONS = {
  AIRCRAFT_NOT_LANDED: "Aircraft did not land at ABO terminal.",
  TRIP_CANCELLED: "The trip was cancelled.",
  NO_PAYMENT: "Aircraft landed, but the pilot did not pay.",
};
export const REJECTION_REASONS_COMMERCIAL = {
  AIRCRAFT_NOT_LANDED: "Commercial Airline did not land at ABO terminal.",
  TRIP_CANCELLED: "The Commercial Airline was cancelled.",
};
export const REJECTION_REASONS_COMMERCIAL_LIST = [
  REJECTION_REASONS_COMMERCIAL.AIRCRAFT_NOT_LANDED,
  REJECTION_REASONS_COMMERCIAL.TRIP_CANCELLED,
];
export const REJECTION_REASONS_LIST = [
  REJECTION_REASONS.AIRCRAFT_NOT_LANDED,
  REJECTION_REASONS.TRIP_CANCELLED,
  REJECTION_REASONS.NO_PAYMENT,
];

export const TRIP_STATUS = {
  UPCOMING: "Upcoming",
  HISTORICAL: "Historical",
  CANCELLED: "Cancelled",
  COMPLETED: "Completed",
  REJECTED: "Rejected",
  INVOICED: "Invoiced",
  PAID: "Paid",
  PARTIALLY_PAID: "Partial Paid",
};

// Trip status codes (backend API values)
export const TRIP_STATUS_CODES = {
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  REJECTED: "REJECTED",
  INVOICED: "INVOICED",
  PAID: "PAID",
  PARTIALLY_PAID: "PARTIALLY_PAID",
};

export const REJECT_BUTTON_DISABLED_STATUSES = [
  TRIP_STATUS_CODES.CANCELLED,
  TRIP_STATUS_CODES.REJECTED,
  TRIP_STATUS_CODES.INVOICED,
  TRIP_STATUS_CODES.PAID,
  TRIP_STATUS_CODES.PARTIALLY_PAID,
];

export const INVOICE_STATUS_LABEL = {
  PAID: "Paid",
  SETTLED: "Settled",
  VERIFICATION_PENDING: "Verification Pending",
};

export const ABO_INVOICE_STATUS = {
  CREATED: "CREATED",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
  OVERDUE: "OVERDUE",
  PAID: "PAID",
  SETTLED: "SETTLED",
  VERIFICATION_PENDING: "VERIFICATION_PENDING",
};

// Sentry configuration constants
export const LOCALHOST_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];
// Aircraft engine types
export const AIRCRAFT_ENGINE_TYPES = {
  PISTON: "PISTON",
  TURBOPROP: "TURBOPROP",
  TURBOSHAFT: "TURBOSHAFT",
};

// Airport types
export const AIRPORT_TYPES = {
  DOMESTIC: "DOM",
  INTERNATIONAL: "INT",
};

// FBO Role codes
export const FBO_ROLE_CODES = {
  FBO_ADMIN: "FBO_ADMIN",
  FBO_EMPLOYEE: "FBO_EMPLOYEE",
};

// Currency codes
export const CURRENCY_CODES = {
  BSD: "BSD",
  USD: "USD",
};

// Payment method codes
export const PAYMENT_METHOD_CODES = {
  WIRE_TRANSFER: "WIRE_TRANSFER",
  CREDIT_CARD: "CREDIT_CARD",
};

// Payment status
export const PAYMENT_STATUS = {
  PAID: "Paid",
  PARTIAL_PAID: "Partial Paid",
  OVERPAID: "Overpaid",
};

// Promise status
export const PROMISE_STATUS = {
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
  PENDING: "pending",
};

// Keyboard keys
export const KEYBOARD_KEYS = {
  BACKSPACE: "Backspace",
  DELETE: "Delete",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  TAB: "Tab",
};

// Data types
export const DATA_TYPES = {
  NUMBER: "number",
  STRING: "string",
  BOOLEAN: "boolean",
  OBJECT: "object",
};

// FBO type URL parameters
export const FBO_TYPE_URL_PARAMS = {
  LANDING_FEE: "landing-fee",
  FUEL_ROYALTY: "fuel-royalty",
  AIRPORT_BASED_OPERATORS: "airport-based-operators",
};

// Empty string constant
export const EMPTY_STRING = "";

// Aircraft tabs
export const AIRCRAFT_TABS = {
  COMMERCIAL: "commercial",
  PRIVATE: "private",
};

// Notification filter types
export const NOTIFICATION_FILTERS = {
  ALL: "all",
  READ: "read",
  UNREAD: "unread",
};

// Browser notification permission states
export const NOTIFICATION_PERMISSIONS = {
  DEFAULT: "default",
  GRANTED: "granted",
  DENIED: "denied",
};

// Environment types
export const ENVIRONMENT = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  TEST: "test",
};

// Airport updating types
export const AIRPORT_UPDATING_TYPES = {
  ORIGIN: "origin",
  DESTINATION: "destination",
};

// Form field keys
export const FORM_FIELD_KEYS = {
  AIRCRAFT_REGISTRATION_NUMBER: "aircraftRegistrationNumber",
};

export const getFlightNumber = (item) => {
  if (item?.iataFlightNumber) {
    return item?.iataFlightNumber;
  } else if (item?.icaoFlightNumber) {
    return item?.icaoFlightNumber;
  } else {
    return item?.flightNumber;
  }
};
export const getOrdinalDateText = (day) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const value = day % 100;
  const suffix =
    suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
  return `${day}${suffix} of Each Month`;
}